import { styled, Grid } from "@mui/material";

export const GridContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(2),
}));
